var _style, _line, _polyline, _polyline2, _circle, _circle2, _line2, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#081754;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#081754;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.5,
    y1: 5.4,
    x2: 13.5,
    y2: 5.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "20.2,7.9 21.5,7.9 21.5,10.9 20.2,10.9 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.7,10.9 2.5,10.9 2.5,7.9 3.7,7.9 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 7.2,
    cy: 16.3,
    r: 1.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.8,
    cy: 16.3,
    r: 1.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.2,
    y1: 12.9,
    x2: 3.8,
    y2: 12.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,19.8H5c-0.7,0-1.3-0.6-1.3-1.3V6.1c0-1.9,1.6-3.4,3.4-3.4h9.6c2-0.1,3.5,1.5,3.5,3.4v12.4 C20.2,19.2,19.7,19.8,18.9,19.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,19.8v0.9c0,0.3-0.2,0.5-0.5,0.5H4.2c-0.3,0-0.5-0.2-0.5-0.5v-2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,18.7v2.1c0,0.3-0.2,0.5-0.5,0.5h-0.5c-0.3,0-0.5-0.2-0.5-0.5v-0.9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 8.2,
    className: "st0",
    width: 1,
    height: 2.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 8.2,
    className: "st0",
    width: 0.8,
    height: 2.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.6,
    y: 19.7,
    className: "st1",
    width: 1.4,
    height: 1.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 19.8,
    className: "st1",
    width: 1,
    height: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.cb8dbbdd7c3cd8fdd8c63da4a9ed52de.svg";
export { ForwardRef as ReactComponent };